import type { InternalAxiosRequestConfig } from 'axios';

/**
 * The PIB / PEB editors' counterpart of manifest-write-block: staff opening
 * another PPJK's draft (not impersonating) can use the whole editor, but its
 * writes are answered locally with blockedWriteAdapter's 403 and never reach
 * the backend. On only while such an editor is mounted: these prefixes are
 * shared with the draft list, uploads, BC23 and master screens.
 */
let blocked = false;

export const setPabeanWriteBlock = (on: boolean) => {
  blocked = on;
};

// What the editors write: the draft tabs, barang and dokumen (/ceisa/edit),
// uploads, submits, tariff syncs and komponen biaya (/ceisa/uploads, v1-v4),
// the importir lookup's inactive flag, and approval requests.
const DRAFT_WRITE = /\/(ceisa\/edit|ceisa\/uploads|ceisa\/jarvis\/lookup-by-npwp|approval)\//i;
// The draft list's own routes are not a draft's.
const NOT_A_DRAFT = /\/ceisa\/edit\/drafts?\//i;
// POSTs that only read (backend rbac ReadSafeSuffixes). Unlike the manifest's
// list it has no "lookup": PATCH lookup-by-npwp/inactive is a write.
const READ_SAFE = /\/(search|filter|list|preview|count|summary|report|suggest|generate-excel|download|print)\b/i;

export const isBlockedPabeanWrite = (config: Pick<InternalAxiosRequestConfig, 'method' | 'url'>): boolean => {
  if (!blocked) return false;
  const method = String(config.method || 'get').toLowerCase();
  if (method === 'get' || method === 'head' || method === 'options') return false;
  const url = config.url ?? '';
  return DRAFT_WRITE.test(url) && !NOT_A_DRAFT.test(url) && !READ_SAFE.test(url);
};
